var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"divRef",staticClass:"wrap-canvas",class:_vm.imageIdx,style:({
    width: _vm.wrapWidth + 'px',
    height: _vm.wrapHeight + 'px'
  })},[(_vm.showImg)?_c('img',{ref:"imgRef",attrs:{"src":_vm.decodeUrl,"width":_vm.innerWidth > 720 ? 720 : _vm.innerWidth},on:{"load":_vm.toCanvas}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }